<rt-box variant="default vertical no-padding" margin-bottom>
  <div layout-vertical>
    <rt-interview-result-summary-overall
      [groups]="groups() ?? []"
      [results]="results() ?? []"
      [candidate]="candidate()"
      [lastUpdate]="lastUpdate()"
      [offerId]="offerId()"
      [currentUserAvailablePlacements]="currentUserAvailablePlacements()"
      [hasAccessToAllJobOffers]="hasAccessToAllJobOffers()"
      [hiddenEvaluationsInfoboxTpl]="hiddenEvaluationsInfoboxTpl()"
      (summaryResultCounterClick)="summaryResultCounterClick.emit($event)"
    />
  </div>
</rt-box>

@for (
  jobSkillsSummary of jobSkillsSummaryDetailsVisible();
  track jobSkillsSummary.job?.id || index;
  let index = $index
) {
  <rt-job-skills-summary-details
    [jobSkillsSummary]="jobSkillsSummary"
    [candidateId]="candidate().id"
    [showJobTitle]="showJobsTitle()"
    [theme]="theme()"
    (viewPosition)="viewPosition.emit($event)"
    margin-bottom
  />
}

@if (scorecardsResults().length > 0) {
  <rt-box variant="default vertical no-padding" margin-bottom>
    <div layout-horizontal>
      <div
        class="box-header"
        padding-left
        padding-tb-small
        layout-horizontal
        layout-space-between
        layout-flex-1
      >
        <rt-heading variant="subheading">
          {{ 'app.interview.summary.scorecards_summary' | translate }}
        </rt-heading>
      </div>
    </div>

    <rt-divider />
    <div layout-vertical>
      <rt-interview-result-summary-scorecards
        [hasHiddenResults]="!!hiddenResultsPreview()?.length"
        [scorecardsResults]="scorecardsResults()"
      />
    </div>
  </rt-box>
}
